(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snugler-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('snugler-reviews')) {
    customElements.define('snugler-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.grid = this.querySelector('[data-grid]');
        this.reviews = Array.from(this.querySelectorAll('[data-review]'));
        this.originalOrder = new Map(this.reviews.map((review, index) => [review, index]));
        this.pageSize = Number(this.dataset.pageSize) || 6;
        this.visibleCount = this.pageSize;
        this.activeRating = 'all';
        this.sortOrder = 'newest';
        this.dialog = this.querySelector('[data-dialog]');
        this.querySelector('[data-controls]').hidden = false;
        this.querySelectorAll('.snr__rating-row').forEach(button => { button.disabled = false; });
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-photo]');
          if (photo && this.contains(photo) && typeof this.dialog.showModal === 'function') {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.photoTrigger = photo;
            const sourceImage = photo.querySelector('img');
            const image = this.querySelector('[data-dialog-image]');
            image.src = photo.href;
            image.alt = sourceImage.alt;
            this.querySelector('[data-dialog-caption]').textContent = sourceImage.alt;
            this.dialog.showModal();
            this.querySelector('[data-close]').focus();
            return;
          }
          const filter = event.target.closest('button[data-rating]');
          if (filter && this.contains(filter)) {
            this.activeRating = filter.dataset.rating;
            this.visibleCount = this.pageSize;
            this.update();
          }
          if (event.target.closest('[data-more]')) {
            const oldCount = this.visibleCount;
            this.visibleCount += this.pageSize;
            this.update();
            const newlyShown = this.filteredReviews[oldCount];
            if (newlyShown) {
              newlyShown.tabIndex = -1;
              newlyShown.focus({ preventScroll: true });
            }
          }
          if (event.target.closest('[data-close]')) this.dialog.close();
          if (event.target === this.dialog) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }
        }, { signal });
        this.querySelector('[data-sort]').addEventListener('change', event => {
          this.sortOrder = event.target.value;
          this.visibleCount = this.pageSize;
          this.update();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          if (this.photoTrigger && this.photoTrigger.isConnected) this.photoTrigger.focus({ preventScroll: true });
          this.querySelector('[data-dialog-image]').removeAttribute('src');
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const selectedReview = event.target.closest('[data-review]');
          if (!selectedReview) return;
          this.activeRating = 'all';
          this.visibleCount = this.reviews.length;
          this.update();
          selectedReview.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, { signal });
        this.update();
      }
      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
      update() {
        this.filteredReviews = this.reviews.filter(review => this.activeRating === 'all' || review.dataset.rating === this.activeRating);
        this.filteredReviews.sort((first, second) => {
          const ratingDifference = Number(second.dataset.rating) - Number(first.dataset.rating);
          if (this.sortOrder === 'highest' && ratingDifference) return ratingDifference;
          if (this.sortOrder === 'lowest' && ratingDifference) return -ratingDifference;
          const newestDifference = (Date.parse(second.dataset.date) || 0) - (Date.parse(first.dataset.date) || 0);
          return newestDifference || this.originalOrder.get(first) - this.originalOrder.get(second);
        });
        this.reviews.forEach(review => { review.hidden = true; });
        this.filteredReviews.forEach((review, index) => {
          review.hidden = index >= this.visibleCount;
          this.grid.append(review);
        });
        this.querySelectorAll('button[data-rating]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.rating === this.activeRating)); });
        const shown = Math.min(this.visibleCount, this.filteredReviews.length);
        this.querySelector('[data-status]').textContent = this.dataset.statusTemplate.replace('__shown__', String(shown)).replace('__total__', String(this.filteredReviews.length));
        this.querySelector('[data-empty]').hidden = this.filteredReviews.length !== 0;
        this.querySelector('[data-more-wrap]').hidden = shown >= this.filteredReviews.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
